import axios from 'axios'
import { attachSessionExpiryInterceptors } from '@ms/shared/services/session_expiry'

const instance = axios.create({
	baseURL: process.env.REACT_APP_MAIN_ENDPOINT,
})

attachSessionExpiryInterceptors(instance, 'token')

export default instance
